<!--<app-time-picker-select #from (ngModelChange)="startChange($event)" [ngModel]="_startValue"></app-time-picker-select>-->
<ng-content select="app-time-picker-select[appStartTime]"></ng-content>

<span> {{separator}} </span>
<!--<app-time-picker-select #to [min]="_startValue || '00:00'" (ngModelChange)="endChange($event)" [ngModel]="_endValue"></app-time-picker-select>-->
<ng-content select="app-time-picker-select[appEndTime]"></ng-content>
